<template>
  <v-card flat  color="#f8f8f8" style="max-width: 100%; top: -12px" class="pa-0 pt-2 px-4">
    <v-card-title class="py-0">
      <span style="font-size: 12px;" class="primary--text">Exchange Rate</span>
      <v-spacer></v-spacer>

      <v-btn
        dark
        small
        v-show="editMode  && currencies.length"
        depressed
        color="amber darken-1"
        @click="create()"
      >
        <v-icon small class="pr-2">mdi-web</v-icon>Reset from Foreign Exchange Rate API
      </v-btn>
      <v-btn
        :flat="!editMode"
        dark
        small
        :color="editMode ? 'ctcGreen' : 'primary'"
        depressed
        v-show="currencies.length"
        @click="editMode ? save() : (editMode = true)"
      >
        <v-icon small class="pr-2">{{ editMode ? "check" : "edit" }}</v-icon>
        {{ editMode ? "Close" : "Edit Rates" }}
      </v-btn>
    </v-card-title>

    <v-card-text v-if="currencies.length == 0">
      <v-layout row wrap justify-center>
        <v-icon color="primary" class="pr-2" small>info</v-icon>You don't have
        any currencies to display.
      </v-layout>
    </v-card-text>

    <v-card-text v-else class="pt-0">
      <v-data-table class="greyTable" hide-actions :items="[1]">
        <template slot="headers">
          <tr style="height:36px">
          <th class="text-xs-left reducedHeaders">Base Currency</th>
          <th
            class="text-xs-left reducedHeaders"
            v-for="currency in currencies"
            :key="currency.name"
          >{{currency.name}}</th></tr>
        </template>

        <template slot="items" slot-scope="props">
          <td :style=" 'padding-top: '+ (editMode ? '16px;' : '0px')">
            <template v-if="editMode">
              <v-select
                dense
                :items="currencies"
                item-value="id"
                item-text="name"
                label="Base Currency:"
                v-model="baseCurrencyID"
              ></v-select>
            </template>
            <template v-else>
              <template v-if="baseCurrencyID">
                <v-label>{{getNameById(baseCurrencyID,"currencies")}}</v-label>
                <span class="pl-4">{{inCurrencyFromId(baseCurrencyID,1)}}</span>
              </template>
            </template>
          </td>
          <td
            :style=" 'padding-top: '+ (editMode ? '16px;' : '0px')"
            v-for="currency in exchangeRates"
            :key="currency.name"
          >
            <template v-if="editMode">
              <v-text-field
                :disabled="currency.id == baseCurrencyID"
                label="Exchange Rate"
                v-model="currency.exchange_rate"
                @change="currency.synchronized_with_api = false"
              >
                <template slot="append">
                  <v-icon
                    :color="currency.synchronized_with_api ? 'success' : ''"
                  >{{currency.synchronized_with_api ? "mdi-api" : "mdi-api-off"}}</v-icon>
                </template>
              </v-text-field>
            </template>
            <template v-else>{{inCurrencyFromId(currency.id,currency.exchange_rate)}}</template>
          </td>
        </template>
      </v-data-table>
    </v-card-text>

    <!-- <v-card-text v-if="currencies.length">
      <v-layout row wrap justify-center>TOTOTO</v-layout>
    </v-card-text>-->
    <v-divider></v-divider>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import currency from "../../../mixins/currency.js";
import {
  convertCurrency,
  getCurrencyRate,
  getCurrencyRateList,
} from "currencies-exchange-rates";
import axios from "axios";

export default {
  name: "exchangeRateTable",
  mixins: [currency],
  data() {
    return {
      editMode: false,
      baseCurrencyID: "",
      exchangeRates: [],
    };
  },
  components: {},
  computed: {
    ...mapGetters("commonStore", ["currencies", "getNameById"]),
    // exchangeRates() {
    //     return this.currencies.map(c => {return {
    //         name: c.name,
    //         exchange
    //     }})
    // }
  },
  props: {},
  methods: {
    save() {
      this.editMode = false;
    },
    cancel() {
      this.editMode = false;
    },
    updateFromApi(currency_code) {
      var graphUrl = `https://api.exchangeratesapi.io/latest?base=${currency_code}&access_key=33e4c95e949530932ce095bf30cfddd3`


      axios.get(graphUrl).then((response) => {
        console.log(response)
        this.exchangeRates.forEach((exr) => {
          exr.exchange_rate = 1;
          exr.synchronized_with_api = false;
          if (response.data.rates[exr.code]) {
            exr.exchange_rate =
              this.getCodeFromId(this.baseCurrencyID) == exr.code
                ? 1
                : response.data.rates[exr.code];
            exr.synchronized_with_api = true;
          }
        });


      });

    },
    resetExchangeRates() {
      var arr = [];
      arr = this.currencies.map((c) => {
        return {
          name: c.name,
          exchange_rate: 1,
          code: c.code,
          id: c.id,
          synchronized_with_api: false,
        };
      });
      return arr;
    },
    create() {
      this.exchangeRates = this.resetExchangeRates();

          if (this.currencies.length) {
            //Select a default currency if at least one currency exists


            let baseCurrency = null

            if (this.currencies.find(c => c.code == "USD"))
              baseCurrency = this.currencies.find(c => c.code == "USD")
            else
              baseCurrency = this.currencies[0]

            console.log(baseCurrency)

            this.baseCurrencyID = baseCurrency.id
            this.updateFromApi(baseCurrency.code);
          }
    }
  },
  created() {
   this.create()
  },
  watch: {
    baseCurrencyID() {
      this.updateFromApi(this.getCodeFromId(this.baseCurrencyID));
      this.$emit("setExchangeRates", this.exchangeRates, this.baseCurrencyID);
    },
  },
};
</script>

<style>
.greyTable .theme--light.v-table  {
  background-color: #f8f8f8 !important;
}
</style>


